import { createContext } from 'react'
import { defaultSubmissionContext, BadDataSubmissionContext } from './BadDataContext.types'

export const badDataSubmissionContext =
  createContext<BadDataSubmissionContext>(defaultSubmissionContext)
